import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

// import { MyErrorHandler } from '../../../../../tools/src/lib/errorhandler/errorhandler';
import { Grade, Year, Class, Subject } from '../../model/school.model';
import { I18nPluralPipe } from '@angular/common';

declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-sch-classsubjecttograde-form',
  templateUrl: './ctl.school.classsubjecttograde.component.html',
  styleUrls: ['./ctl.school.classsubjecttograde.component.css']
})


//export class SchoolSubjectToGradeComponent implements OnInit {
  export class ClassSubjectToGradeComponent implements OnInit {

  @Input() school_id: string;
  @Input() project_id: string;
  @Input() myGrade: any;
  @Input() mySubjectList = [];
  @Input() mySelectedSubjectsList = [];

  @Output() evRemoveSubject: EventEmitter<any> = new EventEmitter();
  @Output() evAddSubject: EventEmitter<any> = new EventEmitter();

  subjectList = [];
  selectedSubjectsList = [];

  subjectListId = [];
  loaded = false;
    textDir:any;
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {

    // jQuery('[data-toggle="tooltip"]').tooltip();

    if (this.mySubjectList) {
        this.subjectList = this.mySubjectList;
    }

  }

  ngAfterViewInit () {
    //
  }

  ngOnChanges(args: any[]) {
    //
  }

  ngDoCheck() {
    if (this.subjectList !== this.mySubjectList) {
        this.subjectList = this.mySubjectList;
        this.loaded = true;
    }
    if (this.selectedSubjectsList !== this.mySelectedSubjectsList) {
        this.selectedSubjectsList = this.mySelectedSubjectsList;
        this.loaded = true;
    }
  }

  checkUncheckSubject(data) {
    console.log('check uncheck' + JSON.stringify(data));
    if (this.mySelectedSubjectsList.find(x => x === data._id) ) {
      this.mySelectedSubjectsList.splice(data._id, 1);
    } else {
      this.mySelectedSubjectsList.push(data._id);
    }

    console.log('after check uncheck' + JSON.stringify(this.mySelectedSubjectsList));
  }

  removeSubject(value) {
    this.evRemoveSubject.emit(value);
  }

  onAddSubject(data) {
    this.evAddSubject.emit(data);
  }

  myListFormatter(item: any): string {
    console.log('data ' + JSON.stringify(item));
    if (item) {
      return `${item['name']}`;
    }
  }

  myValueFormatter(item: any): string {
    console.log('data ' + JSON.stringify(item));
    if (item) {
      return `${item['name']}`;
    }
  }

  isChecked(data) {

    if (this.mySelectedSubjectsList && this.mySelectedSubjectsList.find(x => x === data._id) ) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
  }

}
